<script lang="ts">
	//Design System Components
	import {
		Text,
		SidepanelLayout,
		SidepanelTabs,
		SidepanelContent,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { checkIsComponent } from '../../sidepanel-helpers';
	import { handleSidePanelTabClick, dashTabsConfig } from '../../sidepanel-tabs-helpers';
	import { sidePanelState } from 'src/stores/ui/sidepanel-public';

	const DASH_SIDE_PANEL_CONTENT_CONFIG = [
		'Tab 1 Content Component', // render first tab content component
		'Tab 2 Content Component', // render second tab content component
		'Tab 3 Content Component', // ...
		'Tab 4 Content Component',
	];

	let tabIndex: number = 0;
	let tabs = dashTabsConfig;

	const onTabClick = (e: CustomEvent) => {
		const selectedTabData = e.detail;
		tabIndex = selectedTabData.index;
		tabs = handleSidePanelTabClick(tabs, tabIndex);
	};

	const resetActiveTab = () => {
		tabIndex = 0;
		tabs = dashTabsConfig;
	};

	const handleSettings = () => {
		console.log('Sidepanel Settings clicked');
	};

	$: !$sidePanelState.open ? resetActiveTab() : null;
</script>

<SidepanelLayout title="Dash Side Panel" subtitle="Subtitle" onSettings={handleSettings}>
	<SidepanelContent hideSlotStaticBottom={tabIndex !== 0}>
		<Text>POC SIDE PANEL DASH CONTENT</Text>

		<svelte:component this={checkIsComponent(DASH_SIDE_PANEL_CONTENT_CONFIG?.[tabIndex])} />
		<div slot="staticBottom">static bottom for dash</div>

		<SidepanelTabs slot="tabs" {tabs} on:click={onTabClick} />
	</SidepanelContent>
</SidepanelLayout>
